module.exports = __webpack_public_path__ + "img/icm-praxis.4143754c.svg";